<template>
  <CFooter>
    <div>
      <a href="https://csadv.ru" target="_blank">CSadv</a>
      <span class="ms-1">&copy; 2002-{{ new Date().getFullYear() }}</span>
    </div>
    <div class="ms-auto">
      <span class="me-1" target="_blank">Powered by</span>
      <a href="https://coreui.ilyaklishin.ru" target="_blank">CoreUI for Vue</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
